const Icon = (props: any) => {
    return (
        <svg width={16} height={10} viewBox="0 0 16 10" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
            <path
                d="M10.692 4.028l3.389-3.06a.559.559 0 01.276-.132.592.592 0 01.31.027.53.53 0 01.242.18c.06.08.09.173.091.269v7.376c0 .096-.032.19-.09.27a.53.53 0 01-.242.179.593.593 0 01-.311.027.559.559 0 01-.276-.133l-3.389-3.059M2.615 9.375h6.462c.428 0 .84-.154 1.142-.427a1.39 1.39 0 00.473-1.031V2.083c0-.386-.17-.757-.473-1.03A1.708 1.708 0 009.077.624H2.615c-.428 0-.839.154-1.142.427A1.39 1.39 0 001 2.083v5.834c0 .386.17.757.473 1.03.303.274.714.428 1.142.428z"
                stroke="currentColor"
                strokeWidth={1.225}
                strokeLinecap="round"
            />
        </svg>
    );
};

export default Icon;
